<div class="list-toolbar">
  <p class="hint">
    <mat-icon>info</mat-icon>
    The accounts payouts are sent from. Paying asks which one was used; the Hesabfa export books the payment there.
  </p>
  @if (canEdit) {
  <button mat-flat-button color="primary" type="button" (click)="add()" [disabled]="!!form">
    <mat-icon>add</mat-icon> Add account
  </button>
  }
</div>

@if (form) {
<form class="source-form table-card" (ngSubmit)="save()">
  <mat-form-field appearance="outline" class="f-name" subscriptSizing="dynamic">
    <mat-label>Name</mat-label>
    <input matInput name="name" [(ngModel)]="form.name" required maxlength="100" placeholder="e.g. Blu Bank — Mahdieh Amiri">
  </mat-form-field>
  <mat-form-field appearance="outline" class="f-kind" subscriptSizing="dynamic">
    <mat-label>Kind</mat-label>
    <mat-select name="kind" [(ngModel)]="form.kind" [disabled]="!!form.id">
      <mat-option value="Bank">Bank account</mat-option>
      <mat-option value="Wallet">Crypto wallet</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="f-code" subscriptSizing="dynamic">
    <mat-label>Hesabfa code</mat-label>
    <input matInput name="code" [(ngModel)]="form.hesabfa_code" required maxlength="20" dir="ltr" placeholder="0001">
    <mat-hint>{{ form.kind === 'Bank' ? 'The bank\'s code in Hesabfa' : 'The cash box\'s code in Hesabfa' }}</mat-hint>
  </mat-form-field>
  <mat-form-field appearance="outline" class="f-currency" subscriptSizing="dynamic">
    <mat-label>Currency</mat-label>
    <input matInput name="currency" [(ngModel)]="form.currency" maxlength="10" dir="ltr"
      [placeholder]="form.kind === 'Bank' ? 'IRR' : 'USD'">
  </mat-form-field>
  @if (form.kind === 'Bank') {
  <mat-checkbox name="unspecified" [(ngModel)]="form.is_unspecified" class="f-unspecified">
    Unspecified account
    <span class="sub">For payments whose real source is not known here — e.g. a large one the sarraf paid directly.
      Payments recorded without an account go here too; the accountant moves each to the right account in Hesabfa.</span>
  </mat-checkbox>
  }
  <div class="form-actions">
    <button mat-button type="button" (click)="form = null" [disabled]="saving">Cancel</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="saving || !form.name.trim() || !form.hesabfa_code.trim()">
      Save
    </button>
  </div>
</form>
}

<div class="table-card">
@if (loading) {
<div class="table-state"><mat-spinner diameter="28"></mat-spinner></div>
} @else if (error) {
<div class="table-state error">{{ error }}</div>
} @else if (sources.length === 0) {
<div class="table-state">No accounts yet. Payments cannot be recorded until one is added.</div>
} @else {
<div class="table-scroll">
  <table mat-table [dataSource]="sources">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let s">
        <bdi class="strong">{{ s.name }}</bdi>
        @if (s.is_unspecified) { <span class="badge" matTooltip="Payments whose real source is not known; the accountant assigns it in Hesabfa">Unspecified</span> }
      </td>
    </ng-container>
    <ng-container matColumnDef="kind">
      <th mat-header-cell *matHeaderCellDef>Kind</th>
      <td mat-cell *matCellDef="let s">{{ s.kind === 'Bank' ? 'Bank account' : 'Crypto wallet' }}</td>
    </ng-container>
    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef>Hesabfa code</th>
      <td mat-cell *matCellDef="let s"><span class="mono" dir="ltr">{{ s.hesabfa_code }}</span></td>
    </ng-container>
    <ng-container matColumnDef="currency">
      <th mat-header-cell *matHeaderCellDef>Currency</th>
      <td mat-cell *matCellDef="let s">{{ s.currency }}</td>
    </ng-container>
    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef>Active</th>
      <td mat-cell *matCellDef="let s">
        <mat-slide-toggle [checked]="s.active" [disabled]="!canEdit" (change)="setActive(s, $event.checked)"></mat-slide-toggle>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let s" class="actions">
        @if (canEdit) {
        <button mat-icon-button type="button" matTooltip="Edit" (click)="edit(s)"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button type="button" matTooltip="Delete (only if never paid from)" (click)="remove(s)"><mat-icon>delete</mat-icon></button>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns" [class.inactive]="!row.active"></tr>
  </table>
</div>
}
</div>
